import type { Nullable } from 'corgi-types';
import { ArticleLabelType } from 'graphql-ts-types';

import type { ArticleLabel, ArticleLabelsList } from 'common/types/labels';

export const getLabelValueLength = (label: Nullable<ArticleLabel>) => {
  if (!label?.value) return 0;

  const val = label.value;
  if (typeof val !== 'object' || val === null) return 0;

  if ('value' in val && typeof val.value === 'string') {
    return val.value.length;
  }

  if ('intValue' in val && typeof val.intValue === 'number') {
    return val.intValue.toString().length;
  }

  return 0;
};

export const sortLabels = (
  labels_v2: ArticleLabelsList = [],
  home24Selection?: Nullable<ArticleLabel>
) =>
  home24Selection
    ? labels_v2
        .filter(label => label?.type !== ArticleLabelType.Home24Selection)
        .sort((a, b) => getLabelValueLength(b) - getLabelValueLength(a))
    : labels_v2.sort((a, b) => getLabelValueLength(b) - getLabelValueLength(a));
